import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';

const CreateOfferActionModal = ({ open, onClose, onAction }) => {
  const handleAction = (action) => {
    onAction(action);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: 400,
          width: '100%'
        }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" component="div" fontWeight="bold">
          Create Offer
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          How would you like to proceed with the offer?
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => handleAction('attach')}
            sx={{
              py: 1.5,
              borderColor: '#0044C6',
              color: '#0044C6',
              '&:hover': {
                borderColor: '#0033a0',
                backgroundColor: 'rgba(0, 68, 198, 0.04)'
              }
            }}
          >
            Attach Manually
          </Button>
          
          <Button
            variant="contained"
            fullWidth
            onClick={() => handleAction('createLater')}
            sx={{
              py: 1.5,
              bgcolor: '#0044C6',
              '&:hover': {
                bgcolor: '#0033a0'
              }
            }}
          >
            Generate with AI
          </Button>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button 
          onClick={onClose}
          sx={{ color: '#666' }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateOfferActionModal;